import { axios } from "../services/axios";
import { DOWNLOAD_INVOICE, BILLS_AND_PAYMENTS } from "../constants/paths";
import { BillsAndPaymentsDTO, DownloadInvoiceDTO } from "./interface/invoice";

/**
 * Download API Call
 * @param {DownloadInvoiceDTO} data
 * @returns {Promise<any>}
 */
export const downloadInvoiceApiCall = (
  data: DownloadInvoiceDTO
): Promise<any> => {
  return axios.get(DOWNLOAD_INVOICE + data.id);
};

/**
 * todays inspection API call for inspector dashboard
 * @param  userId
 * @returns {Promise<any>}
 */
export const billsAndPaymentsApiCall = (
  data: BillsAndPaymentsDTO,
  userId: number
): Promise<any> => {
  return axios.get(`${BILLS_AND_PAYMENTS}/${userId}`, {
    params: data,
  });
};
